import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { getProductImages } from '../utils/productImages';

function ProductCard({ product }) {
  const images = useMemo(() => getProductImages(product), [product]);
  const [currentImg, setCurrentImg] = useState(0);
  const averageRating = Number(product.average_rating || 0);
  const reviewCount = Number(product.review_count || 0);

  useEffect(() => {
    // Only start carousel if there are multiple images
    if (!images || images.length <= 1) return;
    
    const timer = setInterval(() => {
      setCurrentImg(i => (i + 1) % images.length);
    }, 2500);
    return () => clearInterval(timer);
  }, [images]);

  return (
    <Link to={`/product/${product.slug || product.id}`} className="hp-product-card">
      <div className="hp-card-img-wrap">
        {images.length > 0 ? (
          images.map((img, i) => (
            <img
              key={i}
              src={img}
              alt={product.name}
              className={`hp-card-img${currentImg === i ? ' visible' : ''}`}
              loading="lazy"
            />
          ))
        ) : (
          <div className="hp-card-no-img">No Image</div>
        )}
        {images.length > 1 && (
          <div className="hp-card-dots">
            {images.map((_, i) => (
              <span key={i} className={`hp-dot${currentImg === i ? ' active' : ''}`} />
            ))}
          </div>
        )}
      </div>
      <div className="hp-card-info">
        <p className="hp-card-name">{product.name}</p>
        {reviewCount > 0 && (
          <div className="hp-card-rating" aria-label={`${averageRating.toFixed(1)} out of 5 from ${reviewCount} reviews`}>
            <span className="hp-card-stars">
              {[1, 2, 3, 4, 5].map(star => (
                <span key={star} className={star <= Math.round(averageRating) ? 'filled' : ''}>{'\u2605'}</span>
              ))}
            </span>
            <span>{averageRating.toFixed(1)} ({reviewCount})</span>
          </div>
        )}
        <p className="hp-card-price">KES {parseFloat(product.price).toLocaleString('en-KE', {minimumFractionDigits:2, maximumFractionDigits:2})}</p>
      </div>
    </Link>
  );
}

export default ProductCard;
